import { createFileRoute } from '@tanstack/react-router';
import { loginErrorReasonResponseSchema } from '@/features/auth/schemas/login.schemas';
import { LoginPage } from '@/features/auth/pages/LoginPage';

export const Route = createFileRoute('/_public/login')({
  validateSearch: (search) => {
    const parsed = loginErrorReasonResponseSchema
      .optional()
      .safeParse((search as Record<string, unknown>).reason);
    return { reason: parsed.success ? parsed.data : undefined };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { reason } = Route.useSearch();

  return <LoginPage reason={reason} />;
}
